import { createStyles } from 'utils/css'
import { ColorProps } from 'utils/types'

export const userStyles = () =>
  createStyles(({ spacing }) => ({
    padding: spacing([0.75, 1, 0, 1]),
    display: 'flex',
    alignItems: 'flex-end',
    flex: 1
  }))

export const menu = (brandColor: ColorProps) =>
  createStyles(({ colors, fontSizes, spacing, radii }) => ({
    width: '100%',
    borderRadius: radii.lg,
    border: `1px solid ${!brandColor ? colors.purple20 : colors.grey10}`,
    background: colors.light,
    color: colors.grey25,
    marginBottom: spacing(0.5),
    '& > #preferences-btn': {
      borderRadius: `${radii.lg} ${radii.lg} 0 0`,
      borderBottom: `1px solid ${colors.grey10}`,
      '& a': {
        padding: 0
      }
    },
    '& > #logout-btn': {
      borderRadius: `0 0 ${radii.lg} ${radii.lg}`
    },
    '& button, & a': {
      display: 'flex',
      alignItems: 'center',
      fontSize: fontSizes.sm,
      padding: spacing(0.6),
      textDecoration: 'none !important',
      width: '100%',
      '&:hover, &:focus': {
        background: brandColor ? brandColor.hex : colors.purple5,
        color: brandColor?.isDark ? colors.light : colors.grey25,
        '& svg': {
          fill: brandColor?.isDark ? colors.light : colors.grey25
        }
      },
      '& svg': {
        marginRight: spacing(0.5),
        fill: colors.grey25
      }
    }
  }))

export const menuWrap = () =>
  createStyles(({ spacing }) => ({
    position: 'absolute',
    left: 0,
    right: spacing(1),
    top: `-${spacing(7.5)}`,
    maxWidth: '180px'
  }))

export const userMenu = (brandColor: ColorProps) =>
  createStyles(({ colors, justifications }) => ({
    color: !brandColor ? colors.grey10 : colors.grey20,
    display: 'flex',
    justifyContent: justifications.between,
    alignItems: 'center'
  }))

export const userMenuBtn = (brandColor: ColorProps) =>
  createStyles(({ colors, radii, spacing }) => ({
    padding: spacing([0.75, 0.5]),
    width: '100%',
    position: 'relative',
    borderRadius: radii.lg,
    border: `2px solid ${brandColor ? colors.grey15 : colors.purple15}`,
    cursor: 'pointer',
    '&:hover, &:focus': {
      borderColor: brandColor ? brandColor.hex : colors.purple10
    }
  }))

export const small = (brandColor: ColorProps) =>
  createStyles(({ fontSizes, effects, colors, size }) => ({
    fontSize: fontSizes.xs,
    fontWeight: 600,
    lineHeight: 1.1,
    ...effects.ellipsis,
    maxWidth: '125px',
    width: 'calc(100% - 50px)',
    '& > div': {
      color: !brandColor ? colors.grey10 : colors.grey20,
      fontWeight: 'normal',
      fontSize: size(1),
      ...effects.ellipsis
    },
    '& svg': {
      color: !brandColor ? colors.light : colors.grey20
    }
  }))
